import { setIsLoading } from './set-is-loading';

export const startLoadingCategory = categoryId => setIsLoading('category', categoryId, true);



// WEBPACK FOOTER //
// ./app/actions/start-loading-category.js